/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  BLSAccount,
  BLSAccountInterface,
} from "../../../../contracts/samples/bls/BLSAccount";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IEntryPoint",
        name: "anEntryPoint",
        type: "address",
      },
      {
        internalType: "address",
        name: "anAggregator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[4]",
        name: "oldPublicKey",
        type: "uint256[4]",
      },
      {
        indexed: false,
        internalType: "uint256[4]",
        name: "newPublicKey",
        type: "uint256[4]",
      },
    ],
    name: "PublicKeyChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IEntryPoint",
        name: "entryPoint",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "SimpleAccountInitialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "addDeposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "aggregator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "entryPoint",
    outputs: [
      {
        internalType: "contract IEntryPoint",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dest",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "func",
        type: "bytes",
      },
    ],
    name: "execute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "dest",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "value",
        type: "uint256[]",
      },
      {
        internalType: "bytes[]",
        name: "func",
        type: "bytes[]",
      },
    ],
    name: "executeBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getBlsPublicKey",
    outputs: [
      {
        internalType: "uint256[4]",
        name: "",
        type: "uint256[4]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "anOwner",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[4]",
        name: "aPublicKey",
        type: "uint256[4]",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[4]",
        name: "newPublicKey",
        type: "uint256[4]",
      },
    ],
    name: "setBlsPublicKey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "tokensReceived",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
      {
        internalType: "bytes32",
        name: "userOpHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "missingAccountFunds",
        type: "uint256",
      },
    ],
    name: "validateUserOp",
    outputs: [
      {
        internalType: "uint256",
        name: "validationData",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "withdrawAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawDepositTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type BLSAccountConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BLSAccountConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BLSAccount__factory extends ContractFactory {
  constructor(...args: BLSAccountConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    anEntryPoint: PromiseOrValue<string>,
    anAggregator: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<BLSAccount> {
    return super.deploy(
      anEntryPoint,
      anAggregator,
      overrides || {}
    ) as Promise<BLSAccount>;
  }
  override getDeployTransaction(
    anEntryPoint: PromiseOrValue<string>,
    anAggregator: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      anEntryPoint,
      anAggregator,
      overrides || {}
    );
  }
  override attach(address: string): BLSAccount {
    return super.attach(address) as BLSAccount;
  }
  override connect(signer: Signer): BLSAccount__factory {
    return super.connect(signer) as BLSAccount__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BLSAccountInterface {
    return new utils.Interface(_abi) as BLSAccountInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BLSAccount {
    return new Contract(address, _abi, signerOrProvider) as BLSAccount;
  }
}
